import { render, staticRenderFns } from "./SlideUpButton.vue?vue&type=template&id=0b63b051&scoped=true&"
import script from "./SlideUpButton.vue?vue&type=script&lang=js&"
export * from "./SlideUpButton.vue?vue&type=script&lang=js&"
import style0 from "./SlideUpButton.vue?vue&type=style&index=0&id=0b63b051&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b63b051",
  null
  
)

export default component.exports